export const sizeMapper = {
    s: 48,
    m: 56,
    l: 64,
} as const;
